import { render, staticRenderFns } from "./self-lottery-rtp.vue?vue&type=template&id=4b60ff52&"
import script from "./self-lottery-rtp.vue?vue&type=script&lang=js&"
export * from "./self-lottery-rtp.vue?vue&type=script&lang=js&"
import style0 from "./self-lottery-rtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports